export default "__VITE_ASSET__ff8a67d4__"